/** Attachment shape from API (list may send JSON string, detail sends array) */
export type EmailAttachment = {
  filename: string;
  contentType: string;
  size: number;
  contentId?: string;
  isInline?: boolean;
};

/**
 * Prefer explicit isInline; if missing (legacy), fall back to contentId.
 * Gmail often sets Content-ID on real attachments — isInline=false must win.
 */
export function isNonInlineEmailAttachment(att: EmailAttachment): boolean {
  return !(att.isInline ?? !!att.contentId);
}

/**
 * Normalize email.attachments (array or JSON string) and return only
 * non-embedded, non-inline attachments (same logic as backend sync).
 */
export function getNonEmbeddedAttachments(
  attachments: Array<EmailAttachment> | string | undefined | null,
): EmailAttachment[] {
  let list: EmailAttachment[] = [];
  if (Array.isArray(attachments)) {
    list = attachments;
  } else if (typeof attachments === 'string') {
    try {
      const parsed = JSON.parse(attachments);
      list = Array.isArray(parsed) ? parsed : [];
    } catch {
      list = [];
    }
  }
  return list.filter(isNonInlineEmailAttachment);
}
